import React, { Suspense, lazy } from 'react'
import { Routes, Route } from 'react-router-dom'
import LoadingBrand from 'components/LoadingBrand'

const HomeHatoHeart = lazy(() => import('pages/hato-heart/HomeHatoHeart'))
const RedirectHHToLiff = lazy(() => import('pages/RedirectHHToLiff'))
const BurnPoints = lazy(() => import('pages/hato-heart/BurnPoints'))
const Coupons = lazy(() => import('pages/hato-heart/Coupons'))

interface RoutePage {
  path: string
  component: React.ComponentType
}

export const basePath = '/hato-heart'
export enum HatoHeartPages {
  Home = '/',
  RedirectHHToLiff = '/home',
  BurnPoints = '/burn-points',
  Coupons = '/coupons',
}

const hatoHeartPages: RoutePage[] = [
  { path: HatoHeartPages.Home, component: HomeHatoHeart },
  { path: HatoHeartPages.RedirectHHToLiff, component: RedirectHHToLiff },
  { path: HatoHeartPages.BurnPoints, component: BurnPoints },
  { path: HatoHeartPages.Coupons, component: Coupons },
]

const HatoHeartRouter = () => {
  return (
    <Suspense fallback={<LoadingBrand show={true} />}>
      <Routes>
        {hatoHeartPages.map((route) => (
          <Route key={route.path} path={route.path} element={<route.component />} />
        ))}
      </Routes>
    </Suspense>
  )
}

export default HatoHeartRouter
